import {Box, CardActionArea, CardMedia, styled} from '@mui/material';

export const StyledBox = styled(Box)`
	position: relative;
	flex-shrink: 0;
	padding: 0 16px 16px 16px;
	width: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 0;
		width: auto;
	}
`;

export const StyledCardMedia = styled(CardMedia)`
	display: block;
	object-fit: cover;
	height: 160px;
	max-height: 160px;
	border-radius: 8px;
	width: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		height: 96px;
		width: 160px;
		max-height: none;
		border-radius: 12px 0 0 12px;
	}
`;

export const StyledPlayer = styled(Box)`
	width: 48px;
	height: 48px;
	position: absolute;
	bottom: 24px;
	left: 24px;

	${({theme}) => theme.breakpoints.up('sm')} {
		bottom: 8px;
		left: 8px;
	}
`;

export const StyledCardActionArea = styled(CardActionArea)`
	display: flex;
	flex-direction: column-reverse;
	align-items: stretch;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`;
